import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { GraphQLData, BlogPostFrontmatter, CardFeaturedPosts } from "@wp/ui"

const FeaturedPosts: React.FC<{}> = () => {
  const data: GraphQLData<BlogPostFrontmatter> = useStaticQuery(graphql`
    query {
      allMarkdownRemark(
        sort: { order: DESC, fields: [frontmatter___date] }
        filter: {
          frontmatter: {
            templateKey: { eq: "blog-post" }
            featuredpost: { eq: true }
          }
        }
      ) {
        edges {
          node {
            excerpt(pruneLength: 400)
            id
            fields {
              slug
            }
            frontmatter {
              title
              templateKey
              description
              date(formatString: "MMMM DD, YYYY")
              featuredpost
              image {
                childImageSharp {
                  fluid(maxWidth: 1200, quality: 60) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
              imageCredit
            }
          }
        }
      }
    }
  `)
  const { edges: posts } = data.allMarkdownRemark
  return <CardFeaturedPosts posts={posts} />
}
export default FeaturedPosts
